import React, { useEffect, useState } from 'react';
export default function AuthGate({ children }) {
  const [user, setUser] = useState(undefined);
  const [username, setUsername] = useState('andrew');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const expired = () => { setUser(null); setError('Your session expired. Log in to continue; unsaved changes remain in browser recovery storage.'); };
    window.addEventListener('kdm-auth-expired', expired);
    fetch('/api/auth/session').then(r => { if (!r.ok) throw Error('Unable to check login'); return r.json(); })
      .then(d => setUser(d.user)).catch(e => { setError(e.message); setUser(null); });
    return () => window.removeEventListener('kdm-auth-expired', expired);
  }, []);
  async function login(e) {
    e.preventDefault(); setError(''); setBusy(true);
    try {
      const r = await fetch('/api/auth/login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username, password }) });
      const d = await r.json(); if (!r.ok) throw Error(d.error);
      setPassword(''); setUser(d.user);
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  }
  if (user === undefined) return <p>Checking login…</p>;
  if (user) return children;
  return <main style={{ maxWidth: 420, margin: '10vh auto', padding: 24 }}>
    <h1>Kingdom Death Manager</h1><p>Your settlements and survivors, saved on Apollo.</p>
    <form onSubmit={login} style={{ display: 'grid', gap: 16 }}>
      <label>Username<input name="username" autoComplete="username" value={username} onChange={e => setUsername(e.target.value)} style={{ display: 'block', padding: 10, width: '100%', boxSizing: 'border-box' }} /></label>
      <label>Password<input name="password" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required style={{ display: 'block', padding: 10, width: '100%', boxSizing: 'border-box' }} /></label>
      <button disabled={busy}>{busy ? 'Signing in…' : 'Log in'}</button>
      {error && <p role="alert">{error}</p>}
    </form>
  </main>;
}
